// @flow

import React, {type AbstractComponent} from 'react';

import {ErrorBoundary} from 'app/general/structures/ErrorBoundary';

export function renderNullOnError(name: string) {
  return function <Config: {}>(
    ErrorProtectedComponent: AbstractComponent<Config>
  ): AbstractComponent<Config> {
    return function ErrorEater(props: Config) {
      return (
        <ErrorBoundary name={name}>
          <ErrorProtectedComponent {...props} />
        </ErrorBoundary>
      );
    };
  };
}
